export const USER_STATUS_DEFINITIONS = "/UserStatus/GetUserStatusDef"






